var exports = {
  "_8": "x936d19a0--0a925e--img",
  "xP": "x936d19a0--0a925e--letter-img",
  "n1": "x936d19a0--0a925e--circle",
};

module.exports = exports;
